import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  container: css`
    && {
      box-shadow: none;
      background: var(--colorScheme-background, #fff);
      overflow-y: scroll !important;
      max-height: 80vh;
    }

    :global(html[data-theme='dark']) & {
      background: var(--colorScheme-background, #191918) !important;
    }
  `,
}
